import ControlButton from 'widget/components/ControlButton';
import mediaQueries from 'styles/mediaQueries';
import mediaQueryBuilder from 'styles/helpers/mediaQueryBuilder';
import styled from '@emotion/styled';

type Props = {
  'data-test'?: string;
  onClick: () => void;
  sizeToHide: string;
};

const StyledSpeedButton = styled(ControlButton)<Props>(({ sizeToHide }) => ({
  [mediaQueryBuilder(`${sizeToHide}`)]: {
    display: 'none',
  },
  [mediaQueryBuilder([
    mediaQueries.max.height['99'],
    mediaQueries.max.width['420'],
  ])]: {
    display: 'none',
  },
}));

export default StyledSpeedButton;
